import { Search, X } from "lucide-react";
import { FilterSelect, type FilterSelectOption } from "../common/FilterSelect";

interface RunsFilterBarProps {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  agentFilter: string;
  onAgentChange: (val: string) => void;
  statusFilter: string;
  onStatusChange: (val: string) => void;
  agentOptions: FilterSelectOption[];
  statusOptions: FilterSelectOption[];
}

export function RunsFilterBar({
  searchQuery,
  onSearchChange,
  agentFilter,
  onAgentChange,
  statusFilter,
  onStatusChange,
  agentOptions,
  statusOptions,
}: RunsFilterBarProps) {
  return (
    <div className="p-2.5 border-b border-stone-100 dark:border-stone-800/80 shrink-0 space-y-2">
      <div className="relative">
        <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-stone-400 dark:text-stone-500 pointer-events-none" />
        <input
          type="text"
          placeholder="Search run ID, entry point, model, tool..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-8 pr-7 py-1.5 text-xs bg-white dark:bg-stone-900 text-stone-900 dark:text-stone-100 placeholder:text-stone-400 dark:placeholder:text-stone-500 border border-stone-200 dark:border-stone-800 focus:outline-hidden focus:ring-1 focus:ring-stone-400 dark:focus:ring-stone-600 font-sans shadow-2xs"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => onSearchChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-600 dark:hover:text-stone-300"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <FilterSelect
          label="Agent"
          value={agentFilter}
          onChange={onAgentChange}
          options={agentOptions}
        />
        <FilterSelect
          label="Status"
          value={statusFilter}
          onChange={onStatusChange}
          options={statusOptions}
        />
      </div>
    </div>
  );
}
